import PatientNoteDialog from './PatientNoteDialog';

export default PatientNoteDialog;
